<template>
	<div>
		<loading v-if="!isLoaded">Loading</loading>
		<div v-else>
			<form-textfield
				:placeholder="placeholderText"
				@input="ResourceSearch"
				v-model="searchTerm"
			/>
			<div v-if="selectedResource && !formattedSearchResults">
				<p>
					<strong>Currently selected:</strong>
				</p>
				<resource-card :resource="selectedResource" />
			</div>
			<div v-else>
				<div
					v-if="
						searchTerm &&
							formattedSearchResults &&
							formattedSearchResults.content &&
							formattedSearchResults.content.length > 0
					"
				>
					<h4>Pages</h4>
					<div
						class="summary"
						v-for="page in formattedSearchResults.content"
						:key="page.id"
						@click="setSelectedResource(page)"
					>
						<p>{{ page.name }}</p>
					</div>
				</div>
				<div
					v-if="
						searchTerm &&
							formattedSearchResults &&
							formattedSearchResults.policies &&
							formattedSearchResults.policies.length > 0
					"
				>
					<h4>Policies</h4>
					<div
						class="summary"
						v-for="policy in formattedSearchResults.policies"
						:key="policy.id"
						@click="setSelectedResource(policy)"
					>
						<p>{{ policy.name }}</p>
					</div>
				</div>
				<div
					v-if="
						searchTerm &&
							formattedSearchResults &&
							formattedSearchResults.eforms &&
							formattedSearchResults.eforms.length > 0
					"
				>
					<h4>E-Forms</h4>
					<div
						class="summary"
						v-for="form in formattedSearchResults.eforms"
						:key="form.id"
						@click="setSelectedResource(form)"
					>
						<p>{{ form.name }}</p>
					</div>
				</div>
				<div
					v-if="
						searchTerm &&
							formattedSearchResults &&
							formattedSearchResults.surveys &&
							formattedSearchResults.surveys.length > 0
					"
				>
					<h4>Surveys</h4>
					<div
						class="summary"
						v-for="survey in formattedSearchResults.surveys"
						:key="survey.id"
						@click="setSelectedResource(survey)"
					>
						<p>{{ survey.name }}</p>
					</div>
				</div>
				<div
					v-if="
						searchTerm &&
							formattedSearchResults &&
							formattedSearchResults.polls &&
							formattedSearchResults.polls.length > 0
					"
				>
					<h4>Polls</h4>
					<div
						class="summary"
						v-for="poll in formattedSearchResults.polls"
						:key="poll.id"
						@click="setSelectedResource(poll)"
					>
						<p>{{ poll.name }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
const ResourceCard = () => import('@/components/ResourceCard.vue')
import debounce from 'lodash/debounce'
import { mapGetters } from 'vuex'
export default {
	props: {
		showValidTick: {
			type: Boolean,
			default: false,
		},
		model: {
			type: String,
		},
		id: {
			type: String,
		},
		name: {
			type: String,
		},
		value: {
			type: String,
		},
		includeContent: {
			type: Boolean,
			default: true,
		},
		includePolicies: {
			type: Boolean,
			default: false,
		},
		includeForms: {
			type: Boolean,
			default: false,
		},
		includeEforms: {
			type: Boolean,
			default: true,
		},
		includeSurveys: {
			type: Boolean,
			default: true,
		},
    placeholderText: {
      type: String,
      default: "Search for a page, policy or form"
    }
	},
	components: {
		ResourceCard,
	},

	data() {
		return {
			isLoaded: true,
			results: null,
			selectedResource: null,
			searchTerm: null,
		}
	},

	created() {
		this.selectedResource = JSON.parse(this.model)
	},

	computed: {
		...mapGetters('documents', ['formattedSearchResults']),
	},

	methods: {
		setSelectedResource(resource) {
			this.selectedResource = resource
			this.results = null
			this.searchTerm = ''
			this.$store.dispatch('documents/clearSearch')
			this.emitSelect(resource)
		},
		emitSelect(selectedOption, id) {
			this.$emit('change', JSON.stringify(selectedOption))
		},
		ResourceSearch: debounce(function(query) {
			if (query.length < 1) {
				return
			}
			const { includeForms, includeContent, includePolicies, includeEforms, includeSurveys } = this
			this.$store
				.dispatch('documents/listAllForSelect', {
					query,
					includeForms,
					includeContent,
					includePolicies,
					includeEforms,
					includeSurveys
				})
				.then((results) => {
          console.log("TCL:  ~ file: FormResource.vue ~ line 157 ~ .then ~ results", results)
					// this.results = null;
					// TODO: Should be a getter?
				})
		}, 500),
	},
}
</script>

<style scoped lang="scss">
h4 {
	font-weight: 700;
	background: #e8edee;
	padding: 0.5em;
	margin-bottom: 0;
}

.summary {
	border: 1px solid #e8edee;
	padding: 0.5em;
	border-top: 0;
	cursor: pointer;

	&:hover {
		background: #f4f6f7;
	}

	p {
		margin: 0;
	}
}
</style>
